export enum EditModes {
    Read  = 0,
    Create = 1,
    Update = 2,
    Delete = 3,
}
